import { gql } from 'src/__generated__'

export default gql(`
  mutation updateCanteen($data: UpdateCanteenInput!) {
    updateCanteen(data: $data) {
      id
    }
  }
`)
